import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Inbox,
  FileText,
  ListChecks,
  Bell,
  Settings,
  Calendar,
  PanelLeftClose,
  PanelLeftOpen,
} from 'lucide-react';
import clsx from 'clsx';
import { useLocalStorage } from '@/hooks/useLocalStorage';

// End-user nav. Internal pages (Queue/Workers) are still routed (URL works)
// but hidden from the sidebar — they live under Settings → Advanced.
const ITEMS = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/applications', label: 'Applications', icon: ListChecks },
  { to: '/calendar', label: 'Calendar', icon: Calendar },
  { to: '/notifications', label: 'Notifications', icon: Bell },
  { to: '/resumes', label: 'Resumes', icon: FileText },
  { to: '/settings', label: 'Settings', icon: Settings },
];

export function Sidebar() {
  const [collapsed, setCollapsed] = useLocalStorage('jobapplier_admin_sidebar_collapsed', false);
  return (
    <aside
      className={clsx(
        'hidden shrink-0 border-r border-gray-200 bg-white py-4 transition-all dark:border-gray-800 dark:bg-gray-900 lg:block',
        collapsed ? 'w-14 px-1' : 'w-56 px-3',
      )}
    >
      <div className={clsx('mb-4 flex items-center', collapsed ? 'flex-col gap-2' : 'justify-between px-2')}>
        {!collapsed && (
          <div>
            <h1 className="text-base font-semibold tracking-tight">
              <Inbox className="mr-1 inline h-4 w-4 text-primary-600" />
              JobApplier
            </h1>
            <p className="text-xs text-gray-500">admin</p>
          </div>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          className="rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
        >
          {collapsed ? <PanelLeftOpen className="h-4 w-4" /> : <PanelLeftClose className="h-4 w-4" />}
        </button>
      </div>
      <nav className="flex flex-col gap-0.5">
        {ITEMS.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            title={collapsed ? it.label : undefined}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-2 rounded-md text-sm transition',
                collapsed ? 'justify-center px-1 py-2' : 'px-2.5 py-1.5',
                isActive
                  ? 'bg-primary-50 font-medium text-primary-800 dark:bg-primary-500/20 dark:text-primary-100'
                  : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800',
              )
            }
          >
            <it.icon className="h-4 w-4 shrink-0" />
            {!collapsed && it.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
